/**
 * Homepage mobile entry animation — headline fade + char reveal + nav pop (≤989px).
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  const REDUCED_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  const wait = function (ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  };

  const nextFrame = function () {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        resolve(undefined);
      });
    });
  };

  const splitLineIntoChars = function (lineEl) {
    if (!lineEl || lineEl.dataset.introCharsReady === 'true') return;

    const text = lineEl.textContent || '';
    lineEl.textContent = '';
    lineEl.dataset.introCharsReady = 'true';

    [...text].forEach(function (char) {
      const span = document.createElement('span');
      span.className = 'editorial-homepage__mobile-headline-char';
      span.textContent = char;
      if (char === ' ') {
        span.classList.add('is-space');
      }
      lineEl.appendChild(span);
    });
  };

  const revealChars = async function (lineEl, delayMs) {
    const chars = lineEl ? lineEl.querySelectorAll('.editorial-homepage__mobile-headline-char') : [];
    for (let index = 0; index < chars.length; index += 1) {
      chars[index].classList.add('is-visible');
      await wait(delayMs);
    }
  };

  const runIntro = async function (root) {
    if (!root || root.dataset.mobileIntroInitialized === 'true') return;
    if (!MOBILE_MQ.matches) return;

    root.dataset.mobileIntroInitialized = 'true';

    const headline = root.querySelector('[data-mobile-intro-headline]');
    const lines = headline ? headline.querySelectorAll('.editorial-homepage__mobile-headline-line') : [];
    const line1 = lines[0] || null;
    const line2 = lines[1] || null;

    if (REDUCED_MQ.matches) {
      root.classList.add('is-intro-line1-visible', 'is-intro-complete');
      if (line2) {
        splitLineIntoChars(line2);
        line2.classList.add('is-intro-line2-active');
        line2.querySelectorAll('.editorial-homepage__mobile-headline-char').forEach(function (char) {
          char.classList.add('is-visible');
        });
      }
      return;
    }

    if (line2) {
      splitLineIntoChars(line2);
    }

    root.classList.add('is-intro-line1-visible');
    await wait(760);

    if (line2) {
      line2.classList.add('is-intro-line2-active');
      await revealChars(line2, 54);
    }

    await wait(160);
    await nextFrame();
    await nextFrame();
    root.classList.add('is-intro-complete');
  };

  const boot = function () {
    document.querySelectorAll('.editorial-homepage[data-mobile-intro]').forEach(function (root) {
      runIntro(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
